import { Api_GenerateSso_Old } from "../../utils/ApiEndpoints";
import {
  T_GenerateSSOOldPay,
  T_GenerateSSOOldRes,
  T_RedirectApiPayload,
} from "./Sso_Types";
import { CSApiService } from "../../redux-store/CSApiService";
import { T_ApiResponse } from "../../globalTypes/GlobalTypes";

export const ssoRtk = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    generateSso_Old: builder.query<
      T_ApiResponse<T_GenerateSSOOldRes>,
      T_GenerateSSOOldPay
    >({
      query: (payload) => ({
        url: Api_GenerateSso_Old,
        method: "POST",
        body: payload,
      }),
    }),
    redirectUrlApi: builder.query<any, T_RedirectApiPayload>({
      query: (payload) => ({
        url: payload.url,
        method: payload.type,
        body: payload.data,
        headers: payload.headers,
      }),
      transformResponse: async (response: any, meta: any, arg) => {
        console.log("redirect URL headers: ", meta);
        return {
          payload: response,
          headers: { ...meta },
          config: { ...meta.config },
        };
      },
    }),
  }),
});

export const { useLazyGenerateSso_OldQuery, useLazyRedirectUrlApiQuery } =
  ssoRtk;
